import React from 'react';
import { motion } from 'framer-motion';
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'left' | 'right' | 'none';
}) {
  const yOffset = direction === 'up' ? 40 : 0;
  const xOffset = direction === 'left' ? 40 : direction === 'right' ? -40 : 0;
  return <motion.div initial={{
    opacity: 0,
    y: yOffset,
    x: xOffset
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-61">
      {children}
    </motion.div>;
}